import React from "react";
import { Button } from "@tennr/frontend/components/Button";
import { InView } from "@tennr/frontend/components/InView";
import { DynamicText } from "@tennr/frontend/components/DynamicText";
import { Link } from "@tanstack/react-router";
import "./CaseStudiesTestimonialSection.css";

export const CaseStudiesTestimonialSection: React.FC = () => {
  return (
    <section className="case-studies-testimonial-section">
      <div className="case-studies-testimonial-container">
        <div className="case-studies-testimonial-content">
          <InView>
            <DynamicText as="div" className="case-studies-testimonial-label">
              TESTIMONIALS
            </DynamicText>
          </InView>

          <InView delay={0.1} amount={0.1}>
            <DynamicText as="blockquote" className="case-studies-testimonial-quote">
              "Before Tennr, we could only work at the speed of our manpower. Adding Tennr has allowed us to expedite
              patient access to care and reallocate staff to patient-facing tasks..."
            </DynamicText>
          </InView>

          <InView delay={0.2}>
            <div className="case-studies-testimonial-attribution">
              <img
                src="/figma/img/cal.png"
                alt="Cal Critchfield"
                className="case-studies-testimonial-avatar"
                draggable={false}
              />
              <div className="case-studies-testimonial-details">
                <DynamicText as="div" className="case-studies-testimonial-name">
                  Cal Critchfield
                </DynamicText>
                <DynamicText as="div" className="case-studies-testimonial-title">
                  Area Vice President, MGA Homecare
                </DynamicText>
              </div>
            </div>
          </InView>

          <InView delay={0.3}>
            <Link to="/studies/mga">
              <Button>READ CASE STUDY</Button>
            </Link>
          </InView>
        </div>
      </div>
    </section>
  );
};
